import ENUMS from '../enums/carouselEnums';

import { createEnumReducer } from '../../../core/js/utils/reducerUtils';

export const carouselSubReducer = createEnumReducer(ENUMS);
